import { Share, Bookmark, Volume2, Loader } from "react-feather"
import React, { useState } from "react";
import { TeaserEntry } from "../helper/interfaces";
import Drawer from "./ui/Drawer";
import { AppContext } from "../provider/AppContextProvider";

interface SharingMenuNNProps {
  teaser: TeaserEntry
  sharingUrl: string
  onClose: () => void
}

const SharingMenuNN = ({ teaser, sharingUrl, onClose }: SharingMenuNNProps) => {
  const { bookmarkedTeaserIds, setBookmarkedTeaserIds, setAudioPlayer, subscription } = React.useContext(AppContext);
  const [copyToClipboardMessage, setCopyToClipboardMessage] = useState("")
  const [lectaLoading, setLectaLoading] = useState(false)
  const [lectaProcessing, setLectaProcessing] = useState(false)

  const showLecta = !teaser.paid || subscription.nnPlusApp || subscription.nnPlusWeb
  
  // share
  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: teaser.title,
          text: teaser.lead,
          url: sharingUrl
        });
      } catch (error) {
        copyToClipboard();
      }
    } else {
      copyToClipboard();
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(sharingUrl)
      .then(() => {
        setCopyToClipboardMessage("In Zwischenablage kopiert");
      })
      .catch(err => {
        setCopyToClipboardMessage("Fehler beim Kopieren in die Zwischenablage");
      });
  };

  // bookmarks
  const addToBookmarkedTeasers = (item: TeaserEntry) => {
    if (!isItemIncluded(item)) {
      setBookmarkedTeaserIds([...(bookmarkedTeaserIds ?? []), item.id]);
    }
  };

  const removeFromBookmarkedTeasers = (item: TeaserEntry) => {
    setBookmarkedTeaserIds(bookmarkedTeaserIds && bookmarkedTeaserIds.filter((e) => e !== item.id));
  };

  const isItemIncluded = (item: TeaserEntry) => {
    return bookmarkedTeaserIds && bookmarkedTeaserIds.find((m) => m == item.id) != undefined;
  };

  // lecta
  const loadLecta = async () => {
    try {
      const res = await fetch(`/api/lecta/get/${teaser.id}`);
      if (res.ok) {
        const json = await res.json();
        if(json?.status == 'DONE') {
          setLectaProcessing(false)
          setAudioPlayer({
            topline: teaser.topline,
            title: teaser.title,
            playing: true,
            audioUrl: json?.audio?.contents[0]?.url,
            imageUrl: teaser.imageUrl,
          });
          onClose()
        }
        else {
          if(json?.status == 'NEW' && !lectaLoading) {
            const resProcess = await fetch(`/api/lecta/process/${teaser.id}`);
            setLectaProcessing(true)
            setTimeout(() => {
              loadLecta()
            }, 5000)
          }
          else {
            setTimeout(() => {
              loadLecta()
            }, 5000)
          }
        }
      } else if(res.status === 404) {
        const resProcess = await fetch(`/api/lecta/process/${teaser.id}`);
        setLectaProcessing(true)
        setTimeout(() => {
          loadLecta()
        }, 5000)
      }
      else {
        console.log("HTTP error", res.status, await res.text());
        setLectaLoading(false)
        setLectaProcessing(false)
      }
    } catch (error) {
      console.error("Network error:", error);
      setLectaLoading(false)
      setLectaProcessing(false)
    }
  };

  const startLecta = () => {
    if(!lectaLoading) {
      setLectaLoading(true)
      loadLecta()
    }
    else {
      setLectaLoading(false)
    }
  }

  return (
    <Drawer onClose={onClose}>
      <div className="sharing-menu__content-list">
        <button className="sharing-menu__content-list-item" key={'Artikel_teilen'} onClick={() => handleShare()}>
            <Share />
          <div className="item-content">
            <p>{'Artikel teilen'}</p>
            {copyToClipboardMessage &&
              <span className="item-info"> {copyToClipboardMessage}</span>
            }
          </div>
        </button>
        <button className="sharing-menu__content-list-item" key={'Artikel_merken'} onClick={() => { isItemIncluded(teaser) ? removeFromBookmarkedTeasers(teaser): addToBookmarkedTeasers(teaser)}}>
            <Bookmark />
          <div className="item-content">
            <p>{isItemIncluded(teaser) ? 'Artikel auf der Merkliste' : 'Artikel merken'}</p>
          </div>
        </button>
        {showLecta && <button className="sharing-menu__content-list-item" key={'Artikel_vorlesen'} onClick={() => { startLecta()}}>
          {!lectaLoading && <Volume2 />}
          {lectaLoading && <Loader className={'spin'}/>}
          <div className="item-content">
            {!lectaProcessing && <p>Artikel vorlesen lassen</p>}
            {lectaProcessing && <p>Artikel wird vorbereitet</p>}
          </div>
        </button>}
      </div>
    </Drawer>
  )
}

export default SharingMenuNN